export default "__VITE_ASSET__DFIbdKTI__"